
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/loan-guide",
      function () {
        return require("private-next-pages/loan-guide/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/loan-guide"])
      });
    }
  